import api from "..";
import type {
  IIllegalParkingReportResponse,
  IParkingBeesEvChargerVacancyResponse,
} from "./type";

const isProductionApp =
  process.env.NODE_ENV === "production" ||
  process.env.REACT_APP_ENV === "prod" ||
  process.env.REACT_APP_ENV === "production";

const ASGARD_RECIPIENT = isProductionApp
  ? ["hello@asgardev.com.hk"]
  : ["edison@wasphk.com"];

export const sendUserFeedback = async (
  name: string,
  email: string,
  phone: string,
  message: string,
) => {
  const response = await api.post<{ statusCode: number }>(
    `/email/send-general-email`,
    {
    sender: "no-reply@asgardev.com.hk",
    recipient: ASGARD_RECIPIENT, //TODO: update email
    subject: "Asgard EV - 用戶意見反映／查詢",
    body: `
    <p>姓名: ${name}</p>
    <p>電郵: ${email}</p>
    <p>電話: ${phone}</p>
    <p>意見/查詢內容: ${message}</p>`,
    },
  );

  return response.data;
};

export const getEVInfo = async (ms_token?: string) => {
  const response = await api.post<IParkingBeesEvChargerVacancyResponse[]>(
    `/ev_charger_session_record/get-ev-charger-vacancy-and-estimate-availability-by-token`,
    {
      ms_token: ms_token ? ms_token : undefined,
    },
  );

  return response.data;
};

// export const getEVConfig = async () => {
//   const response = await api.get<any[]>(
//     `/ev_charger_session_record/get-all-supported-ev-config`
//   );

//   return response.data;
// };

export const getExistingConfirmedReports = async () => {
  const response = await api.get<IIllegalParkingReportResponse[]>(
    `/illegal-parking-reports/get-existing-confirmed-reports`,
  );

  return response.data;
};

export const createIllegalParkingReport = async (
  parking_id: number,
  plate: string,
  remark: string,
  file: File,
) => {
  const response = await api.post<IIllegalParkingReportResponse>(
    `/illegal-parking-reports`,
    {
      parking_id,
      car_plate: plate,
      remark,
      file,
      source: "asgard-ev-app",
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};
